import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import { useAppContext } from '../../context/AppContext';
import logo from '../../assets/logo-getit.png';
import logoPosgo from '../../assets/logo-posgo.png';

const PaymentMethodScreen = () => {
    const { total } = useCart();
    const { settings, setOrderType } = useAppContext();
    const navigate = useNavigate();
    const [visible, setVisible] = useState(false);
    const [checkingXSign, setCheckingXSign] = useState(false);
    const [xsignError, setXsignError] = useState(false);

    useEffect(() => {
        const t = setTimeout(() => setVisible(true), 50);
        return () => clearTimeout(t);
    }, []);

    const handleOrderTypeClick = async (type) => {
        setXsignError(false);
        setCheckingXSign(true);
        try {
            const xsignUrl = settings?.xsignUrl || 'http://localhost:5999';
            const controller = new AbortController();
            const timeout = setTimeout(() => controller.abort(), 2000);
            const response = await fetch(`${xsignUrl}/ping`, { signal: controller.signal });
            clearTimeout(timeout);
            if (response.ok) {
                setOrderType(type);
                navigate('/operate-card');
            } else {
                setXsignError(true);
            }
        } catch {
            setXsignError(true);
        } finally {
            setCheckingXSign(false);
        }
    };

    return (
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: '#f5f5f5' }}>

            {/* Header — igual que CategorySelectionScreen */}
            <div style={{
                background: 'white',
                padding: '1.5rem',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                boxShadow: '0 2px 8px rgba(0,0,0,0.07)',
                position: 'relative'
            }}>
                <img src={logo} alt="GetIT" style={{ height: '100px', width: 'auto' }} />
                <div style={{ position: 'absolute', right: '1.5rem', display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                    <img src={logoPosgo} alt="PosGo" style={{ height: '80px', width: 'auto' }} />
                    <span style={{ fontSize: '1.5rem', fontWeight: 700, color: '#db2113', fontFamily: 'Quicksand, sans-serif' }}>PosGo.cl</span>
                </div>
            </div>

            {/* Contenido */}
            <div style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '3rem 4rem',
                gap: '3rem'
            }}>
                {/* Título y monto */}
                <div style={{
                    textAlign: 'center',
                    opacity: visible ? 1 : 0,
                    transform: visible ? 'translateY(0)' : 'translateY(-30px)',
                    transition: 'opacity 0.5s ease, transform 0.5s ease'
                }}>
                    <h1 style={{
                        fontFamily: "'Montserrat', sans-serif",
                        fontSize: '5rem',
                        fontWeight: 900,
                        color: '#0E8164',
                        margin: '0 0 1rem 0',
                        lineHeight: 1.1
                    }}>
                        Tu Orden Total
                    </h1>
                    <p style={{
                        fontSize: '4rem',
                        fontWeight: 800,
                        color: '#1a1a1a',
                        margin: 0
                    }}>
                        ${total.toLocaleString()}
                    </p>
                </div>

                {/* Dos botones: Para Servir / Para Llevar */}
                <div style={{
                    display: 'flex', gap: '2rem', width: '100%', maxWidth: '800px',
                    opacity: visible ? 1 : 0,
                    transform: visible ? 'translateY(0)' : 'translateY(40px)',
                    transition: 'opacity 0.6s ease 0.2s, transform 0.6s ease 0.2s'
                }}>
                    {[
                        {
                            type: 'servir',
                            label: 'Para Servir',
                            icon: (
                                <svg viewBox="0 0 24 24" width="140" height="140" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#0E8164" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                    <path d="M7 4v17m-3 -17v3a3 3 0 1 0 6 0v-3"/>
                                    <path d="M14 8a3 4 0 1 0 6 0a3 4 0 1 0 -6 0"/>
                                    <path d="M17 12v9"/>
                                </svg>
                            )
                        },
                        {
                            type: 'llevar',
                            label: 'Para Llevar',
                            icon: (
                                <svg viewBox="0 0 24 24" width="140" height="140" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#0E8164" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                    <path d="M6.331 8h11.339a2 2 0 0 1 1.977 2.304l-1.255 8.152a3 3 0 0 1 -2.966 2.544h-6.852a3 3 0 0 1 -2.965 -2.544l-1.255 -8.152a2 2 0 0 1 1.977 -2.304z"/>
                                    <path d="M9 11v-5a3 3 0 0 1 6 0v5"/>
                                </svg>
                            )
                        },
                    ].map(({ type, label, icon }) => (
                        <button
                            key={type}
                            onClick={() => handleOrderTypeClick(type)}
                            disabled={checkingXSign}
                            style={{
                                flex: 1,
                                background: 'white',
                                border: `4px solid ${xsignError ? '#ef4444' : 'transparent'}`,
                                borderRadius: '28px',
                                padding: '3rem 1rem',
                                cursor: checkingXSign ? 'wait' : 'pointer',
                                boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                                transition: 'all 0.2s ease',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: '1.5rem',
                                opacity: checkingXSign ? 0.7 : 1,
                            }}
                            onMouseEnter={e => {
                                if (checkingXSign) return;
                                e.currentTarget.style.borderColor = xsignError ? '#ef4444' : '#0E8164';
                                e.currentTarget.style.transform = 'translateY(-6px)';
                                e.currentTarget.style.boxShadow = '0 16px 40px rgba(14,129,100,0.2)';
                            }}
                            onMouseLeave={e => {
                                if (checkingXSign) return;
                                e.currentTarget.style.borderColor = xsignError ? '#ef4444' : 'transparent';
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.1)';
                            }}
                        >
                            {icon}
                            <span style={{ fontSize: '2.5rem', fontWeight: 800, color: '#0E8164' }}>
                                {checkingXSign ? 'Verificando...' : label}
                            </span>
                        </button>
                    ))}
                </div>

                {xsignError && (
                    <div style={{
                        background: '#fef2f2',
                        border: '2px solid #ef4444',
                        borderRadius: '16px',
                        padding: '1.2rem 2rem',
                        textAlign: 'center',
                        maxWidth: '700px',
                        width: '100%'
                    }}>
                        <p style={{ fontSize: '1.6rem', fontWeight: 700, color: '#dc2626', margin: 0 }}>
                            Sistema de pago no disponible
                        </p>
                        <p style={{ fontSize: '1.2rem', color: '#991b1b', margin: '0.5rem 0 0 0' }}>
                            Verifique que la aplicación XSign esté activa e intente nuevamente.
                        </p>
                    </div>
                )}
            </div>

            {/* Bottom bar fijo */}
            <div style={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                background: 'white',
                padding: '1rem 2rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                boxShadow: '0 -4px 16px rgba(0,0,0,0.08)',
                zIndex: 40
            }}>
                <button
                    onClick={() => navigate('/payment')}
                    style={{
                        width: '56px',
                        height: '56px',
                        borderRadius: '50%',
                        background: '#0E8164',
                        border: 'none',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15 18l-6-6 6-6" />
                    </svg>
                </button>

                <button
                    onClick={() => navigate('/')}
                    style={{
                        background: '#e5e7eb',
                        border: 'none',
                        borderRadius: '28px',
                        padding: '0.9rem 2rem',
                        fontSize: '1.1rem',
                        fontWeight: 700,
                        color: '#6b7280',
                        cursor: 'pointer'
                    }}
                >
                    Volver al menú
                </button>
            </div>

            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@900&display=swap');
            `}</style>
        </div>
    );
};

export default PaymentMethodScreen;
